export default function WhyFailBeforeMeeting() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const mistakes = [
    { title: 'Отсутствие подготовки', desc: 'Большинство переговорщиков идут на встречу без чёткого плана, не изучив интересы второй стороны, их ограничения и альтернативы. Импровизация в переговорах — главный враг результата.' },
    { title: 'Позиция продавца, а не партнёра', desc: 'Когда переговорщик воспринимает себя как просителя, он автоматически занимает слабую позицию. Переговоры — это равный диалог двух сторон, каждая из которых решает свою задачу.' },
    { title: 'Фокус на цене вместо ценности', desc: 'Компании спорят о скидках вместо того, чтобы обсуждать, какую ценность их продукт создаёт для клиента. Переговоры через ценность меняют всю динамику обсуждения.' },
    { title: 'Игнорирование интересов второй стороны', desc: 'Переговорщики концентрируются на своей выгоде, забывая, что вторая сторона тоже должна получить результат. Без понимания чужих интересов невозможно найти взаимовыгодное решение.' },
    { title: 'Отсутствие системы в компании', desc: 'Каждый менеджер ведёт переговоры по-своему. Нет единых стандартов, скриптов, разбора кейсов. Результат зависит от личности переговорщика, а не от системы.' },
    { title: 'Эмоциональная неготовность', desc: 'Сложные переговоры требуют управления эмоциями — и своими, и чужими. Без этого навыка даже сильная позиция рассыпается при первом давлении.' },
    { title: 'Отсутствие BATNA', desc: 'Наилучшая альтернатива обсуждаемому соглашению — ключевой инструмент переговорщика. Без понимания своей альтернативы компания соглашается на невыгодные условия.' },
    { title: 'Неумение задавать вопросы', desc: 'Переговоры выигрываются вопросами, а не аргументами. Слабые переговорщики говорят — сильные спрашивают и слушают.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему большинство <strong>переговоров</strong> проигрывается ещё до первой встречи
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Результат <strong>деловых переговоров</strong> на 70% определяется подготовкой. Ниже — главные ошибки, которые компании допускают до начала диалога с клиентом, партнёром или поставщиком.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mistakes.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 hover:shadow-md transition-all duration-300 group cursor-default border-l-4 border-red-400">
              <div className="w-10 h-10 bg-red-50 rounded-full flex items-center justify-center mb-4">
                <span className="text-red-500 font-extrabold text-lg">{i + 1}</span>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-teal-50 rounded-2xl p-8 max-w-4xl mx-auto text-center">
          <p className="text-teal-800 font-medium text-lg leading-relaxed">
            <strong>Главная мысль:</strong> переговоры выигрываются не за столом, а на этапе подготовки. Компании, которые инвестируют в системную подготовку переговорщиков, получают на 30–55% лучшие условия сделок.
          </p>
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Построить систему переговоров в компании
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}